import AvailableListingContainer from "../../../../Components/ConsumerGenerator/ListingContainer/AvailableListing/AvailableListingContainer";

const NewLedger = () => {
  return (
    <div
      style={{
        backgroundColor: "#f3f5f8",
        borderRadius: "8px",
        height: "100%",
        overflowY: "auto",
      }}
    >
      <AvailableListingContainer showBackbtn={true} />
    </div>
  );
};

export default NewLedger;
